import React from 'react';

const NotFound = () => (
    <div className="not-found">
        <div id="offline"><b>You are offline.</b> You must be connected to the internet.</div>
    </div>
);

export default NotFound;